import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { Api } from "../../services/api";

export default function SponsorDetail() {
  const { sponsorId } = useParams();
  const { user } = useUser();
  const api = useMemo(() => new Api(), []);
  const [sponsor, setSponsor] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const response = await api.getWithAuth(
        `/api/sponsors/${sponsorId}`,
        user,
      );
      const json = await response.json();
      setSponsor(json);
    };
    getData();
  }, [sponsorId, user, api]);

  return (
    sponsor && (
      <div className="col-span-full px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <Link
            to="/"
            className="text-blue-600 hover:underline mb-4 inline-block"
          >
            ← Back to Home
          </Link>
          <div className="flex flex-col items-center mb-6">
            <img
              src={sponsor.logo.url}
              alt={sponsor.name}
              className="max-h-32 object-contain mb-4"
            />
            <h1 className="text-3xl font-bold mb-2">{sponsor.name}</h1>
            <p className="text-xl text-gray-600">
              {sponsor.category.displayLabel}
            </p>
          </div>
          {sponsor.description && (
            <div className="text-gray-700 mb-6 whitespace-pre-line">
              {sponsor.description[0]?.children[0]?.text}
            </div>
          )}
          <div className="flex gap-4">
            {sponsor.url && (
              <a
                href={sponsor.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Website →
              </a>
            )}
            {sponsor.linkedinPage && (
              <a
                href={sponsor.linkedinPage}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                LinkedIn →
              </a>
            )}
          </div>
        </div>
      </div>
    )
  );
}
